/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { useContext } from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';
import { DegreeIcon } from '@coursera/cds-icons';

import { getMonths } from 'bundles/account-profile/common/constants';
import { ProfileContext } from 'bundles/account-profile/components/recruiting-profile-viewer/ProfileContextProvider';
import shouldShowHighlightsEducationTag from 'bundles/account-profile/components/recruiting-profile-viewer/components/highlights/shouldShowHightlightGraduationTag';

import _t from 'i18n!nls/account-profile';

const styles = {
  tagWrapper: css`
    display: flex;
    align-items: center;
  `,
  tag: () => css`
    display: flex;
    align-items: center;
    border-radius: 4px;
    gap: var(--cds-spacing-50);
    padding: 0 var(--cds-spacing-50);
    height: 22px;
  `,
  graduationTag: () => css`
    background-color: var(--cds-color-grey-25);
  `,
};

const HighlightsSectionTags = () => {
  const monthsArray = getMonths();
  const { profileState = {} } = useContext(ProfileContext);
  const { educationHistory = [] } = profileState;

  if (!educationHistory?.length) return null;

  const latestEducation = educationHistory?.[0];
  const showEducationTag = shouldShowHighlightsEducationTag(educationHistory);

  return (
    <Grid container spacing={8} direction="column" data-testid="highlight-tags-section">
      {showEducationTag && (
        <Grid item css={styles.tagWrapper}>
          <div css={[styles.tag, styles.graduationTag]}>
            <DegreeIcon color="default" />
            <Typography2 component="p" variant="bodySecondary">
              {_t('Graduates #{graduationDate}', {
                // The check for latestEducation is done in shouldShowHighlightsEducationTag
                graduationDate: `${monthsArray[latestEducation!.graduationDate!.month - 1]} ${
                  latestEducation!.graduationDate!.year
                }`,
              })}
            </Typography2>
          </div>
        </Grid>
      )}
    </Grid>
  );
};

export default HighlightsSectionTags;
